// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import addMaximumScaleToViewport from "@insite/client-framework/Common/Utilities/addMaximumScaleToViewport";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import isMobile from "ismobilejs";
import * as React from "react";
import { useEffect } from "react";
import { css } from "styled-components";

export const CreateAccountPage = ({ id }: PageProps) => {
    useEffect(() => {
        if (isMobile(window.navigator).apple.tablet || isMobile(window.navigator).apple.phone) {
            addMaximumScaleToViewport();
        }
    }, []);

    return (
        <Page
            // Xng-Changes
            css={css`
                &&& {
                    margin-bottom: 0;
                    padding-top: 0;
                }
            `}
            fullWidth={[true, true, true, true, true]}
        >
            <Zone requireRows={true} zoneName="Content" contentId={id} />
        </Page>
    );
};

const pageModule: PageModule = {
    component: CreateAccountPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "CreateAccountPage" instead of this constant.
 */
export const CreateAccountPageContext = "CreateAccountPage";
